import type { ImmutableArray } from "shelving";
import { Slides } from "../base/Slides.js";
import { MediaImage } from "./MediaImage.js";

/**
 * Show a carousel of media images.
 */
export function MediaSlides({ paths }: { paths: ImmutableArray<string> }): React.ReactElement | null {
	return paths.length ? <Slides children={paths.map(_mapSlide)} /> : null;
}
function _mapSlide(image: string, i: number) {
	return <MediaImage key={i} path={image} />;
}
